module.exports = __webpack_public_path__ + "static/media/doctor.3f25727c.png";